module.exports = __webpack_public_path__ + "img/blue.bbc4b2cb.png";